import { c as _c } from "react/compiler-runtime";
import { TabBar } from "@website/ui/tab-bar/tab-bar";
import { useTab } from "@website/ui/tabs/tab.hook";
import styles from "@website/ui/tabs/tabs.module.scss";
import { TabsPropertiesType } from "@website/ui/tabs/tabs.types";
import { FC } from "react";
export const Tabs: FC<TabsPropertiesType> = properties => {
  const $ = _c(14);
  const {
    className,
    orientation: t0,
    behavior: t1,
    tabs,
    panel,
    panelContainerClassName
  } = properties;
  const orientation = t0 === undefined ? "horizontal" : t0;
  const behavior = t1 === undefined ? "button" : t1;
  const {
    selectedTab,
    tabBarProperties
  } = useTab(properties);
  const t2 = `${styles.tabs} ${styles[orientation]} ${className ?? ""}`;
  let t3;
  if ($[0] !== tabBarProperties) {
    t3 = <TabBar {...tabBarProperties} />;
    $[0] = tabBarProperties;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `${styles["panels-container"]} ${panelContainerClassName}`;
  let t5;
  if ($[2] !== behavior || $[3] !== panel || $[4] !== selectedTab || $[5] !== tabs) {
    t5 = behavior === "link" || behavior === "custom" ? <div className="" tabIndex={0}>{panel}</div> : tabs.map((item, index) => <div aria-labelledby={`tab-button-${index}`} className="" hidden={selectedTab !== index} id={`tab-${index}`} key={item.title} role="tabpanel" tabIndex={0}>{item.panel}</div>);
    $[2] = behavior;
    $[3] = panel;
    $[4] = selectedTab;
    $[5] = tabs;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};